import { z } from "zod";

export const cloudfrontCookieSchema = z.object({
  "CloudFront-Policy": z.string(),
  "CloudFront-Key-Pair-Id": z.string(),
  "CloudFront-Signature": z.string(),
});

export type CloudfrontCookie = z.infer<typeof cloudfrontCookieSchema>;
